import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../services/API";

export const getReportReasons = createAsyncThunk("getReportReasons", async (_, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get(`/moderation/report-reasons/`);
        return response.data;
    } catch (error) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        }
        return rejectWithValue({ message: "Failed to fetch report reasons" });
    }
});

export const submitPostReport = createAsyncThunk("submitPostReport", async ({ postId, data }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/moderation/posts/${postId}/report/`, data);
        return response.data;
    } catch (error) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        }
        return rejectWithValue({ message: "Failed to report post" });
    }
});

export const homePostReport = createAsyncThunk("homePostReport", async ({ postId, data }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/post/posts/${postId}/report/`, data);
        return response.data;
    } catch (error) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        }
        return rejectWithValue({ message: "Failed to report post" });
    }
});

export const reportCommunityMessage = createAsyncThunk("reportCommunityMessage", async ({ messageId, data }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/neighbor_news/community-messages/${messageId}/report/`, data);
        return response.data;
    } catch (error) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        }
        return rejectWithValue({ message: "Failed to report message" });
    }
});

export const ReportSlice = createSlice({
    name: "ReportSlice",
    initialState: {
        loading: false,
        error: null,
        reportReasons: [],
        reportReasonsLoading: false,
    },
    extraReducers: (builder) => {
        builder
            .addCase(getReportReasons.pending, (state) => {
                state.reportReasonsLoading = true;
            })
            .addCase(getReportReasons.fulfilled, (state, action) => {
                state.reportReasonsLoading = false;
                state.reportReasons = action.payload;
            })
            .addCase(getReportReasons.rejected, (state) => {
                state.reportReasonsLoading = false;
            })
            .addCase(submitPostReport.pending, (state) => {
                state.loading = true;
            })
            .addCase(submitPostReport.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(submitPostReport.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(homePostReport.pending, (state) => {
                state.loading = true;
            })
            .addCase(homePostReport.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(homePostReport.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(reportCommunityMessage.pending, (state) => {
                state.loading = true;
            })
            .addCase(reportCommunityMessage.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(reportCommunityMessage.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default ReportSlice.reducer;
